import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import UpsertShift from "./UpsertShift";

const UpdateShiftModal = ({ allShifts, shift, dayOfWeek, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button type="icon" onClick={() => setIsOpen(true)}>
          <div style={{ color: "#0085B3" }}>
            <Icon tokens={editTokens} />
          </div>
        </Button>
      </Row>

      <Modal
        title="Update Shift"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        {isOpen && (
          <UpsertShift
            allShifts={allShifts}
            shift={shift}
            dayOfWeek={dayOfWeek}
            onSubmit={(daysOfWeek, updatedShift) =>
              onSubmit(daysOfWeek, shift, updatedShift)
            }
            onCancel={() => setIsOpen(false)}
            isEdit={true}
          />
        )}
      </Modal>
    </Column>
  );
};
export default UpdateShiftModal;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/UpdateShiftModal.js